import { StateCreator } from 'zustand'
import { Deal } from '../types'

export interface DealsSlice {
  activeDeals: Deal[]
  addDeal: (deal: Deal) => void
  updateDeal: (id: string, updatedDeal: Partial<Deal>) => void
  removeDeal: (id: string) => void
  setActiveDeals: (deals: Deal[]) => void
}

export const createDealsSlice: StateCreator<DealsSlice> = (set) => ({
  activeDeals: [],
  addDeal: (deal) =>
    set((state) => ({ activeDeals: [...state.activeDeals, deal] })),
  updateDeal: (id, updatedDeal) =>
    set((state) => ({
      activeDeals: state.activeDeals.map((deal) =>
        deal.id === id ? { ...deal, ...updatedDeal } : deal,
      ),
    })),
  removeDeal: (id) =>
    set((state) => ({
      activeDeals: state.activeDeals.filter((deal) => deal.id !== id),
    })),
  setActiveDeals: (deals) => set({ activeDeals: deals }),
})
